const actions = {
  ADD_ACC_BEGIN: 'ADD_ACC_BEGIN',
  ADD_ACC_SUCCESS: 'ADD_ACC_SUCCESS',
  ADD_ACC_ERR: 'ADD_ACC_ERR',

  GET_ACC_BEGIN: 'GET_ACC_BEGIN',
  GET_ACC_SUCCESS: 'GET_ACC_SUCCESS',
  GET_ACC_ERR: 'GET_ACC_ERR',

  DELETE_ACC_BEGIN: 'DELETE_ACC_BEGIN',
  DELETE_ACC_SUCCESS: 'DELETE_ACC_SUCCESS',
  DELETE_ACC_ERR: 'DELETE_ACC_ERR',

  UPDATE_ACC_BEGIN: 'UPDATE_ACC_BEGIN',
  UPDATE_ACC_SUCCESS: 'UPDATE_ACC_SUCCESS',
  UPDATE_ACC_ERR: 'UPDATE_ACC_ERR',

  AddBegin: () => {
    return {
      type: actions.ADD_ACC_BEGIN,
    };
  },

  AddSuccess: (data) => {
    return {
      type: actions.ADD_ACC_SUCCESS,
      data,
    };
  },

  AddErr: (err) => {
    return {
      type: actions.ADD_ACC_ERR,
      err,
    };
  },

  ReadBegin: () => {
    return {
      type: actions.GET_ACC_BEGIN,
    };
  },

  ReadSuccess: (data) => {
    return {
      type: actions.GET_ACC_SUCCESS,
      data,
    };
  },

  ReadErr: (err) => {
    return {
      type: actions.GET_ACC_ERR,
      err,
    };
  },

  UpdateBegin: () => {
    return {
      type: actions.UPDATE_ACC_BEGIN,
    };
  },

  UpdateSuccess: (data) => {
    return {
      type: actions.UPDATE_ACC_SUCCESS,
      data,
    };
  },

  UpdateErr: (err) => {
    return {
      type: actions.UPDATE_ACC_ERR,
      err,
    };
  },

  DeleteBegin: () => {
    return {
      type: actions.DELETE_ACC_BEGIN,
    };
  },

  DeleteSuccess: (data) => {
    return {
      type: actions.DELETE_ACC_SUCCESS,
      data,
    };
  },

  DeleteErr: (err) => {
    return {
      type: actions.DELETE_ACC_ERR,
      err,
    };
  },
};

export default actions;
